export const removeValueFromArray = (array, value) => {
   const result = [];
   for (const item of array) {
      if (item !== value) {
         result.push(item);
      }
   }
   return result;
};

export const mergeWithoutDuplicates = (array1, array2) => {
   const set = new Set([...array1, ...array2]);
   return Array.from(set);
}

export const groupBy = (array, groupFunction) => {
   let results = {}
   for (const item of array) {
      const group = groupFunction(item)
      results[group] = emptyArrayIfNull(results[group])
      results[group].push(item)
   }
   return results
}

export const arrayToObject = (arr, keyProperty) => {
	const obj = {}
	for (const item of arr) {
		obj[item[keyProperty]] = item
	}
	return obj
}

export function sortOnKey(arr, key) {
   return arr.sort((a, b) => {
      const aKey = a[key]
      const bKey = b[key]
      if (aKey < bKey) {
         return -1
      }
      else if (aKey > bKey) {
         return 1
      }
      else {
         return 0
      }
   })
}

export const emptyArrayIfNull = (array) => array == null ? [] : array



// WEBPACK FOOTER //
// ./src/utils/misc.js